<template>
    <b-container fluid>
        <b>{{ 'files' | translate }}</b>
        <br>
        <div class="float-right">
            <b-form-input v-model="searchAssigned" :placeholder="$globalStore.translate('files.search.assigned')" style="min-width: 305px"></b-form-input>
        </div>
        <div class="float-left">
            <b-form-select v-model="currentSortBy" :options="sortOptions" @input="getFiles"></b-form-select>
        </div>
        <br>
        <b-table responsive bordered small :items="files" :fields="fields" :tbody-tr-class="rowClass" hover>
            <template slot="size" slot-scope="data">
                {{ data.item.size | bytes }}
            </template>

            <template slot="uploaded" slot-scope="data">
                {{ data.item.uploaded | date2 }}
            </template>

            <template slot="expire" slot-scope="data">
                {{ data.item.expire | date }}
            </template>

            <template slot="download" slot-scope="data">
                <a v-bind:href="data.item.downloadLink" target="_blank">{{ 'files.table.body.download' | translate }}</a>
            </template>

            <template slot="delete" slot-scope="data" v-if="$globalStore.group === 1">
                <b-dropdown :text="$globalStore.translate('files.table.body.delete')">
                    <b-dropdown-item @click="deleteOneFile(data.item.id)">{{ 'files.table.body.delete.one' | translate }}</b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="deleteFileGroup(data.item.downloadLink)">{{ 'files.table.body.delete.group' | translate }}</b-dropdown-item>
                </b-dropdown>
            </template>
        </b-table>

        <div class="float-right">
            <b>{{ 'pagination.page' | translate(currentPageDisplay, totalPagesDisplay) }}</b>
        </div>
        <ul class="pagination">
            <li
                class="pagination-item"
            >
                <b-button
                    variant="outline-secondary"
                    @click="onClickFirstPage"
                    v-bind:aria-label="$globalStore.translate('pagination.page.first.text')"
                >
                    << {{ 'pagination.page.first' | translate }}
                </b-button>
            </li>

            <li
                class="pagination-item"
            >
                <b-button
                    variant="outline-secondary"
                    @click="onClickPreviousPage"
                    v-bind:aria-label="$globalStore.translate('pagination.page.previous.text')"
                >
                    < {{ 'pagination.page.previous' | translate }}
                </b-button>
            </li>
            <li class="pagination-item">
                <b-button
                    variant="outline-secondary"
                    @click="onClickNextPage"
                    v-bind:aria-label="$globalStore.translate('pagination.page.next.text')"
                >
                    {{ 'pagination.page.next' | translate }} >
                </b-button>
            </li>

            <li class="pagination-item">
                <b-button
                    variant="outline-secondary"
                    @click="onClickLastPage"
                    v-bind:aria-label="$globalStore.translate('pagination.page.last.text')"
                >
                    {{ 'pagination.page.last' | translate }} >>
                </b-button>
            </li>
        </ul>
    </b-container>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "Files",
        data() {
            return {
                files: [],
                fields: [
                    {
                        key: 'index',
                        label: '#'
                    },
                    {
                        key: 'name',
                        label: this.$globalStore.translate('files.table.name')
                    },
                    {
                        key: 'size',
                        label: this.$globalStore.translate('files.table.size')
                    },
                    {
                        key: 'downloads',
                        label: this.$globalStore.translate('files.table.downloads')
                    },
                    {
                        key: 'uploaded',
                        label: this.$globalStore.translate('files.table.uploaded')
                    },
                    {
                        key: 'expire',
                        label: this.$globalStore.translate('files.table.expire')
                    },
                    {
                        key: 'from',
                        label: this.$globalStore.translate('files.table.from')
                    },
                    {
                        key: 'publicOrAssigned',
                        label: this.$globalStore.translate('files.table.public')
                    },
                    {
                        key: 'download',
                        label: this.$globalStore.translate('files.table.download')
                    }
                ],
                sortOptions: [
                    { value: 'fg.uploaded asc', text: 'Hochgeladen aufsteigend' },
                    { value: 'fg.uploaded desc', text: 'Hochgeladen absteigend' },
                    { value: 'f.name asc', text: 'Name aufsteigend' },
                    { value: 'f.name desc', text: 'Name absteigend' },
                    { value: 'f.size asc', text: 'Größe aufsteigend' },
                    { value: 'f.size desc', text: 'Größe absteigend' }
                ],
                searchAssigned: '',
                currentPage: 1,
                currentPageDisplay: 1,
                totalPages: 1,
                totalPagesDisplay: 1,
                showError: false,
                showFilesNotDeleted: false,
                showFilesDeleted: false,
                showErrorListFiles: false,
                filterMode: false,
                currentSortBy: 'fg.uploaded desc'
            }
        },
        methods: {
            rowClass: function (item, type) {
                if (!item) {
                    return
                }

                if (item.switch) {
                    return 'table-secondary'
                }
            },
            onClickFirstPage: function () {
                this.currentPage = 1;

                this.getFiles();
            },
            onClickLastPage: function () {
                this.currentPage = 0;

                this.getFiles();
            },
            onClickNextPage: function () {
                this.currentPage++;

                this.getFiles();
            },
            onClickPreviousPage: function () {
                this.currentPage--;

                this.getFiles();
            },
            highlightFileGroups: function () {
                if (this.files.length === 0) {
                    return;
                }

                let lastFileGroupId = this.files[0].fileGroupId;
                let flag = false;
                for (let i = 0; i < this.files.length; i++) {
                    if (lastFileGroupId !== this.files[i].fileGroupId) {
                        flag = !flag;
                        lastFileGroupId = this.files[i].fileGroupId;
                    }

                    this.$set(this.files[i], 'switch', flag);
                }
            },
            getFiles: function () {
                let endpoint = !this.filterMode ? 'https://drop.rautec.de/api/files/list/' + this.currentPage + '/' + this.currentSortBy.split(" ")[0] + '/' + this.currentSortBy.split(" ")[1] :
                    'https://drop.rautec.de/api/files/list/' + this.currentPage + '/' + this.searchAssigned;

                axios.get(endpoint)
                    .then(response => {
                        if (response.data.files || response.data.error === 0) {
                            this.files = response.data.files;
                            for (let i = 0; i < this.files.length; i++) {
                                // 1 if it is a public download or otherwise the username from the assigned user
                                if (this.files[i].publicOrAssigned === 1) {
                                    this.files[i].publicOrAssigned = this.$globalStore.translate('files.public');
                                }
                            }

                            this.highlightFileGroups();

                            this.currentPage = response.data.currentPage;
                            this.currentPageDisplay = response.data.currentPage;
                            this.totalPages = response.data.totalPages;
                            this.totalPagesDisplay = response.data.totalPages;
                        }
                    }).catch(reason => {
                    this.showErrorListFiles = true;
                });
            },
            deleteOneFile: function (fileId) {
                axios.delete('https://drop.rautec.de/api/file', { params: { id: fileId }}).then(response => {
                    if (response.data.error === 0) {
                        this.$toastSuccess('files.deleted', true);

                        this.getFiles();
                    } else {
                        this.$toastError('files.deleted.not', true);
                    }
                }).catch(reason => {
                    this.$toastError('files.deleted.error', true);
                });
            },
            deleteFileGroup: function (linkWithFileGroupId) {
                let split = linkWithFileGroupId.split('/');

                let foundFileGroupToken = split[split.length - 1];

                if (foundFileGroupToken) {
                    axios.delete('https://drop.rautec.de/api/file/group', {params: {fileGroupToken: foundFileGroupToken}}).then(response => {
                        if (response.data.error === 0) {
                            this.$toastSuccess('files.deleted', true);

                            this.getFiles();
                        } else {
                            this.$toastError('files.deleted.not', true);
                        }
                    }).catch(reason => {
                        this.$toastError('files.deleted.error', true);
                    });
                }
            }
        },
        watch: {
            searchAssigned: function (value, oldValue) {
                if (value === '' && oldValue !== '') {
                    this.filterMode = false;
                    this.getFiles();
                    return;
                }

                if (value.length > 0 && !this.filterMode) {
                    this.filterMode = true;
                }

                this.getFiles();
            },
            $route (to, from) {
                if (to === from) {
                    this.getFiles();
                }
            }
        },
        mounted() {
            // Only show the 'delete' column if the user is admin
            if (this.$globalStore.group === 1) {
                this.fields.push(
                    {
                        key: 'delete',
                        label: this.$globalStore.translate('files.table.delete')
                    });
            }

            this.getFiles();
        }
    }
</script>

<style scoped>
    .pagination {
        list-style-type: none;
        display: flex;
        justify-content: center;
    }

    .pagination-item {
        display: inline-block;
    }

    td {
        max-width: 250px;
        word-wrap: break-word;
    }
</style>



// WEBPACK FOOTER //
// src/components/Files.vue